import React, { useEffect, useState } from "react";
import Head from "../Global/Head";
import Header from "../Global/Header";
import Footer from "../shared/footer/Footer";
import LoginModal from "../main/loginModal/LoginModal";

const Terms = () => {
  const accessToken = localStorage.getItem("@user");
  const [isVisible, setIsVisible] = useState(accessToken ? false : true);
  const [mobileSearchBar, setMobileSearchBar] = useState(false);
  const [topPosition, setTopPosition] = useState(50);

  useEffect(() => {
    let interval;
    const totalTime = 1500;
    const steps = 800;
    const intervalTime = totalTime / steps;
    const decrement = 1300 / steps;

    const increment = 1300 / steps;

    if (isVisible) {
      interval = setInterval(() => {
        setTopPosition((prev) => {
          if (prev <= 0) {
            clearInterval(interval);
            return 0;
          }
          return prev - decrement;
        });
      }, intervalTime);
    }

    return () => clearInterval(interval);
  }, [isVisible]);

  const slideGoDown = () => {
    const totalTime = 1500; // Total animation time
    const steps = 800; // Number of steps
    const intervalTime = totalTime / steps; // Time per step
    const increment = 1300 / steps; // Position change per step

    let interval = setInterval(() => {
      setTopPosition((prev) => {
        if (prev >= 80) {
          clearInterval(interval); // Stop the interval
          setTimeout(() => setIsVisible(false), 0); // Change state after animation ends
          return 80; // Ensure it stops at the original position
        }
        return prev + increment; // Increment position to slide down
      });
    }, intervalTime);
  };

  const BlankModal = ({ isVisible, setIsVisible }) => {
    return (
      <div
        className={`fixed inset-0 z-[1000]  transition-opacity duration-300 ${
          isVisible ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
      >
        <div
          className="absolute inset-0 login-slide-up  bg-black"
          onClick={() => setIsVisible(false)}
        ></div>
        <div className="relative w-full h-screen">
          <div
            style={{ top: `${topPosition}%` }} // Dynamic top position
            className="absolute w-full h-screen transition-none"
          >
            <LoginModal setIsVisible={setIsVisible} slideGoDOwn={slideGoDown} />
          </div>
        </div>
      </div>
    );
  };
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top
  }, []); // Run on mount

  return (
    <>
      <Head />
      <Header />
      <section className="terms-section px-[24px] lightblack mgtop1rem">
        <div className="terms-div">
          <div className="terms-text w-richtext">
            <h1>
              <strong>TERMS AND CONDITIONS</strong>
            </h1>
            <p>
              By using HighTable’s services, you agree to comply with the
              following terms and conditions. Failure to adhere to these rules
              may result in the suspension or termination of your account.
            </p>
            <p>
              <strong>Last updated</strong> <strong>January 06, 2025</strong>
            </p>

            <h2>
              <strong>AGREEMENT TO OUR LEGAL TERMS</strong>
            </h2>
            <p>
              We are High Table Network Private Limited ("
              <strong>Company</strong>," "<strong>we</strong>," "
              <strong>us</strong>," "<strong>our</strong>"), a company
              registered in India at Adya 13 &amp; 14, No 4, 6 Cross, 9th Main,
              Srinivagilu Main Road, Near Koramangala bus depot, Koramangala,
              Bangalore, Karnataka 560047.
            </p>

            <h2>
              <strong>PLATFORM PURPOSE</strong>
            </h2>
            <p>
              HighTable is a platform that connects individuals for in-person
              meet-up and experiences. We are not responsible for the actions of
              any individual or the outcomes of your meetings. We do not
              facilitate other activities beyond connecting users for
              real-world interactions.
            </p>

            <p>
              We operate the website{" "}
              <a href="https://www.hightable.ai/" target="_blank">
                https://www.hightable.ai
              </a>{" "}
              (the "<strong>Site</strong>"), as well as any other related
              products and services that refer or link to these legal terms (the
              "<strong>Legal Terms</strong>") (collectively, the "
              <strong>Services</strong>").
            </p>
            <p>
              You can contact us by phone at +919036433636, email at
              support@hightable.ai, or by mail to Adya 13 &amp; 14, No 4, 6
              Cross, 9th Main, Srinivagilu Main Road, Near Koramangala bus
              depot, Koramangala, Bangalore, Karnataka 560047, India.
            </p>
            <p>
              These Legal Terms constitute a legally binding agreement made
              between you, whether personally or on behalf of an entity ("
              <strong>you</strong>
              "), and High Table Network Private Limited, concerning your access
              to and use of the Services. You agree that by accessing the
              Services, you have read, understood, and agreed to be bound by all
              of these Legal Terms. IF YOU DO NOT AGREE WITH ALL OF THESE LEGAL
              TERMS, THEN YOU ARE EXPRESSLY PROHIBITED FROM USING THE SERVICES
              AND YOU MUST DISCONTINUE USE IMMEDIATELY.
            </p>
            <p>
              Supplemental terms and conditions or documents that may be posted
              on the Services from time to time are hereby expressly
              incorporated herein by reference. We reserve the right, in our
              sole discretion, to make changes or modifications to these Legal
              Terms at any time and for any reason. We will alert you about any
              changes by updating the "Last updated" date of these Legal Terms,
              and you waive any right to receive specific notice of each such
              change. It is your responsibility to periodically review these
              Legal Terms to stay informed of updates. You will be subject to,
              and will be deemed to have been made aware of and to have
              accepted, the changes in any revised Legal Terms by your continued
              use of the Services after the date such revised Legal Terms are
              posted.
            </p>
            <p>
              The Services are intended for users who are at least 18 years old.
              Persons under the age of 18 are not permitted to use or register
              for the Services.
            </p>
            <p>
              We recommend that you print a copy of these Legal Terms for your
              records.
            </p>
            <h2>
              <strong>TABLE OF CONTENTS</strong>
            </h2>
            <p>
              <a href="#services">1. OUR SERVICES</a>
            </p>
            <p>
              <a href="#ip">2. INTELLECTUAL PROPERTY RIGHTS</a>
            </p>
            <p>
              <a href="#userreps">3. USER REPRESENTATIONS</a>
            </p>
            <p>
              <a href="#userreg">4. USER REGISTRATION</a>
            </p>
            <p>
              <a href="#purchases">5. PURCHASES AND PAYMENT</a>
            </p>
            <p>
              <a href="#returnno">6. POLICY</a>
            </p>
            <p>
              <a href="#prohibited">7. PROHIBITED ACTIVITIES</a>
            </p>
            <p>
              <a href="#ugc">8. USER GENERATED CONTRIBUTIONS</a>
            </p>
            <p>
              <a href="#license">9. CONTRIBUTION LICENSE</a>
            </p>
            <p>
              <a href="#socialmedia">10. SOCIAL MEDIA</a>
            </p>
            <p>
              <a href="#thirdparty">11. THIRD-PARTY WEBSITES AND CONTENT</a>
            </p>
            <p>
              <a href="#sitemanage">12. SERVICES MANAGEMENT</a>
            </p>
            <p>
              <a href="#ppno">13. PRIVACY POLICY</a>
            </p>
            <p>
              <a href="#terms">14. TERM AND TERMINATION</a>
            </p>
            <p>
              <a href="#modifications">15. MODIFICATIONS AND INTERRUPTIONS</a>
            </p>
            <p>
              <a href="#law">16. GOVERNING LAW</a>
            </p>
            <p>
              <a href="#disputes">17. DISPUTE RESOLUTION</a>
            </p>
            <p>
              <a href="#corrections">18. CORRECTIONS</a>
            </p>
            <p>
              <a href="#disclaimer">19. DISCLAIMER</a>
            </p>
            <p>
              <a href="#liability">20. LIMITATIONS OF LIABILITY</a>
            </p>
            <p>
              <a href="#indemnification">21. INDEMNIFICATION</a>
            </p>
            <p>
              <a href="#userdata">22. USER DATA</a>
            </p>
            <p>
              <a href="#electronic">
                23. ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES
              </a>
            </p>
            <p>
              <a href="#misc">24. MISCELLANEOUS</a>
            </p>
            <p>
              <a href="#contact">25. CONTACT US</a>
            </p>
            <h2>
              <strong>1. OUR SERVICES</strong>
            </h2>
            <p>
              The information provided when using the Services is not intended
              for distribution to or use by any person or entity in any
              jurisdiction or country where such distribution or use would be
              contrary to law or regulation or which would subject us to any
              registration requirement within such jurisdiction or country.
              Accordingly, those persons who choose to access the Services from
              other locations do so on their own initiative and are solely
              responsible for compliance with local laws, if and to the extent
              local laws are applicable.
            </p>
            <h2>
              <strong>2. INTELLECTUAL PROPERTY RIGHTS</strong>
            </h2>
            <h3>
              <strong>Our intellectual property</strong>
            </h3>
            <p>
              We are the owner or the licensee of all intellectual property
              rights in our Services, including all source code, databases,
              functionality, software, website designs, audio, video, text,
              photographs, and graphics in the Services (collectively, the
              "Content"), as well as the trademarks, service marks, and logos
              contained therein (the "Marks").
            </p>
            <p>
              Our Content and Marks are protected by copyright and trademark
              laws (and various other intellectual property rights and unfair
              competition laws) and treaties around the world.
            </p>
            <p>
              The Content and Marks are provided in or through the Services "AS
              IS" for your personal, non-commercial use only.
            </p>

            <h3 class="font-bold text-lg mb-4">General Restrictions</h3>
            <div class="flex flex-col">
              <p>
                • No Unsolicited Communications: You may not use HighTable to
                send unsolicited emails, collect personal data, or create fake
                accounts.
              </p>
              <p>
                • No Automated Use: Do not engage in automated use of the
                system, such as using scripts, data gathering tools, or
                unauthorized software to interact with the platform.
              </p>
              <p>
                • Respect for Privacy: Do not collect or share any personal
                information about other users without their consent, and always
                respect privacy.
              </p>
            </div>
            <h3 class="font-bold text-lg mb-4">Platform Limitations</h3>
            <div class="flex flex-col">
              <p>
                • HighTable is a Platform for Real-Life Connections: We provide
                a space to connect with people in the real world. HighTable is
                not responsible for the actions or outcomes of these meetings,
                and we do not facilitate financial transactions, direct
                messaging, or virtual communications between users.
              </p>
              <p>
                • No Responsibility for Events: HighTable does not monitor or
                facilitate the events themselves and is not liable for any
                behavior, damage, or issues that arise during these in-person
                gatherings.
              </p>
            </div>

            <h3 class="font-bold text-lg mb-4">Violations and Enforcement</h3>
            <div class="flex flex-col">
              <p>
                • Account Suspension or Termination: We reserve the right to
                suspend or terminate your account if you are found to be in
                violation of any of these Terms & Conditions.
              </p>
              <p>
                • Reporting Violations: If you come across any behavior or
                content that violates these Terms, please report it to us
                through our designated channels.
              </p>
            </div>
            <h3 class=" text-4xl mb-4">HighTable Refund Policy</h3>
            <p class="mb-4">
              At HighTable, we want to make sure you have the best possible
              experience. Please read our refund policy carefully.
            </p>

            <h4 class="font-semibold text-base mb-2">1. Refund Eligibility</h4>
            <div class="">
              <p>
                • Refunds for Table Cancellations by HighTable: If HighTable
                cancels a table (due to low attendance, venue issues, or any
                unforeseen circumstances), you will be eligible for a full
                refund. Refunds will be processed back to the original payment
                method within 7-10 business days.
              </p>
              <p>
                • Refunds for Medical or Emergency Situations: If you are unable
                to attend an event due to medical reasons or an emergency,
                please contact us as soon as possible. While we cannot guarantee
                a refund in all cases, we will do our best to accommodate your
                situation.
              </p>
            </div>

            <h4 class="font-semibold text-base mb-2">
              2. Non-Refundable Conditions
            </h4>
            <div class="">
              <p>
                • No-Show: If you do not attend the event without prior notice,
                a refund will not be issued.
              </p>
              <p>
                • Late Cancellations: If you cancel your booking less than 24
                hours before the event, we cannot offer a refund.
              </p>
            </div>

            <h4 class="font-semibold text-base mb-2">3. Non-Refundable Fees</h4>
            <div class="">
              <p>
                • Processing Fees: Any transaction or processing fees charged by
                third-party payment processors are non-refundable. These fees
                are outside of HighTable’s control.
              </p>
            </div>

            <h3>
              <strong>Your use of our Services</strong>
            </h3>
            <p>
              Subject to your compliance with these Legal Terms, including the "
              <a href="#prohibited">PROHIBITED ACTIVITIES</a>" section below, we
              grant you a non-exclusive, non-transferable, revocable license to:
            </p>
            <ul role="list">
              <li>access the Services; and</li>
              <li>
                download or print a copy of any portion of the Content to which
                you have properly gained access,
              </li>
            </ul>
            <p>solely for your personal, non-commercial use.</p>
            <p>
              Except as set out in this section or elsewhere in our Legal Terms,
              no part of the Services and no Content or Marks may be copied,
              reproduced, aggregated, republished, uploaded, posted, publicly
              displayed, encoded, translated, transmitted, distributed, sold,
              licensed, or otherwise exploited for any commercial purpose
              whatsoever, without our express prior written permission.
            </p>
            <p>
              If you wish to make any use of the Services, Content, or Marks
              other than as set out in this section or elsewhere in our Legal
              Terms, please address your request to: support@hightable.ai. If we
              ever grant you the permission to post, reproduce, or publicly
              display any part of our Services or Content, you must identify us
              as the owners or licensors of the Services, Content, or Marks and
              ensure that any copyright or proprietary notice appears or is
              visible on posting, reproducing, or displaying our Content.
            </p>
            <p>
              We reserve all rights not expressly granted to you in and to the
              Services, Content, and Marks.
            </p>
            <p>
              Any breach of these Intellectual Property Rights will constitute a
              material breach of our Legal Terms and your right to use our
              Services will terminate immediately.
            </p>
            <h3>
              <strong>Your submissions</strong>
            </h3>
            <p>
              Please review this section and the "
              <a href="#prohibited">PROHIBITED ACTIVITIES</a>" section carefully
              prior to using our Services to understand the (a) rights you give
              us and (b) obligations you have when you post or upload any
              content through the Services.
            </p>
            <p>
              <strong>Submissions:</strong> By directly sending us any question,
              comment, suggestion, idea, feedback, or other information about
              the Services ("Submissions"), you agree to assign to us all
              intellectual property rights in such Submission. You agree that we
              shall own this Submission and be entitled to its unrestricted use
              and dissemination for any lawful purpose, commercial or otherwise,
              without acknowledgment or compensation to you.
            </p>
            <p>
              <strong>You are responsible for what you post or upload:</strong>{" "}
              By sending us Submissions through any part of the Services you:
            </p>
            <ul role="list">
              <li>
                confirm that you have read and agree with our "
                <a href="#prohibited">PROHIBITED ACTIVITIES</a>" and will not
                post, send, publish, upload, or transmit through the Services
                any Submission that is illegal, harassing, hateful, harmful,
                defamatory, obscene, bullying, abusive, discriminatory,
                threatening to any person or group, sexually explicit, false,
                inaccurate, deceitful, or misleading;
              </li>
              <li>
                to the extent permissible by applicable law, waive any and all
                moral rights to any such Submission;
              </li>
              <li>
                warrant that any such Submission are original to you or that you
                have the necessary rights and licenses to submit such
                Submissions and that you have full authority to grant us the
                above-mentioned rights in relation to your Submissions; and
              </li>
              <li>
                warrant and represent that your Submissions do not constitute
                confidential information.
              </li>
            </ul>
            <p>
              You are solely responsible for your Submissions and you expressly
              agree to reimburse us for any and all losses that we may suffer
              because of your breach of (a) this section, (b) any third party’s
              intellectual property rights, or (c) applicable law.
            </p>
            <h2>
              <strong>3. USER REPRESENTATIONS</strong>
            </h2>
            <p>
              By using the Services, you represent and warrant that: (1) all
              registration information you submit will be true, accurate,
              current, and complete; (2) you will maintain the accuracy of such
              information and promptly update such registration information as
              necessary; (3) you have the legal capacity and you agree to comply
              with these Legal Terms; (4) you are not a minor in the
              jurisdiction in which you reside; (5) you will not access the
              Services through automated or non-human means, whether through a
              bot, script or otherwise; (6) you will not use the Services for
              any illegal or unauthorized purpose; and (7) your use of the
              Services will not violate any applicable law or regulation.
            </p>
            <p>
              If you provide any information that is untrue, inaccurate, not
              current, or incomplete, we have the right to suspend or terminate
              your account and refuse any and all current or future use of the
              Services (or any portion thereof).
            </p>
            <h2>
              <strong>4. USER REGISTRATION</strong>
            </h2>
            <p>
              You may be required to register to use the Services. You agree to
              keep your password confidential and will be responsible for all
              use of your account and password. We reserve the right to remove,
              reclaim, or change a username you select if we determine, in our
              sole discretion, that such username is inappropriate, obscene, or
              otherwise objectionable.
            </p>
            <h2>
              <strong>5. PURCHASES AND PAYMENT</strong>
            </h2>
            <p>We accept the following forms of payment:</p>
            <p>- Visa</p>
            <p>- Mastercard</p>
            <p>- UPI</p>
            <p>- Net Banking</p>
            <p>
              You agree to provide current, complete, and accurate purchase and
              account information for all purchases made via the Services. You
              further agree to promptly update account and payment information,
              including email address, payment method, and payment card
              expiration date, so that we can complete your transactions and
              contact you as needed. Sales tax will be added to the price of
              purchases as deemed required by us. We may change prices at any
              time. All payments shall be in INR.
            </p>
            <p>
              You agree to pay all charges at the prices then in effect for your
              purchases and any applicable shipping fees, and you authorize us
              to charge your chosen payment provider for any such amounts upon
              placing your order. We reserve the right to correct any errors or
              mistakes in pricing, even if we have already requested or received
              payment.
            </p>
            <p>
              We reserve the right to refuse any order placed through the
              Services. We may, in our sole discretion, limit or cancel
              quantities purchased per person, per household, or per order.
              These restrictions may include orders placed by or under the same
              customer account, the same payment method, and/or orders that use
              the same billing or shipping address. We reserve the right to
              limit or prohibit orders that, in our sole judgment, appear to be
              placed by dealers, resellers, or distributors.
            </p>
            <h2>
              <strong>6. POLICY</strong>
            </h2>
            <h2>
              <strong>7. PROHIBITED ACTIVITIES</strong>
            </h2>
            <body>
              <div>
                <p>
                  1. Misrepresent Your Identity – Including your age,
                  affiliations, or connection to any entity.
                </p>
              </div>

              <div>
                <p>
                  2. Disrupt the Services – Do not damage or interfere with the
                  platform’s functionality or disrupt others’ use of the
                  platform.
                </p>
              </div>

              <div>
                <p>
                  3. Engage in Illegal Activities – Use HighTable for criminal
                  purposes, including fraud, money laundering, or any unlawful
                  conduct.
                </p>
              </div>

              <div>
                <p>
                  4. Harass or Abuse Others – Including bullying, stalking,
                  defamation, or causing psychological harm to others.
                </p>
              </div>

              <div>
                <p>
                  5. Solicit Sensitive Information – Do not ask users for
                  personal data (e.g., passwords, financial details) for
                  unlawful or commercial purposes.
                </p>
              </div>

              <div>
                <p>
                  6. Request Money or Gifts – Do not ask for gifts, money, or
                  any items of value from other users, whether as loans, gifts,
                  or compensation.
                </p>
              </div>

              <div>
                <p>
                  7. Impersonate Other Users – Do not use another person’s
                  account or personal details without consent.
                </p>
              </div>

              <div>
                <p>
                  8. Engage in Fraudulent Practices – Including pyramid schemes,
                  fraud, or other deceptive activities.
                </p>
              </div>

              <div>
                <p>
                  9. Use for Political Campaigning – Do not use HighTable for
                  political campaigning, election manipulation, or any similar
                  activities (unless sharing personal views).
                </p>
              </div>

              <div>
                <p>
                  10. Infringe on Intellectual Property – Do not copy, modify,
                  or distribute content from HighTable or other users without
                  explicit permission.
                </p>
              </div>

              <div>
                <p>
                  11. Claim Endorsement by HighTable – Do not imply that your
                  statements or actions are endorsed by HighTable without
                  written consent.
                </p>
              </div>

              <div>
                <p>
                  12. Use Automation Tools – Do not use bots, crawlers, or other
                  automated systems to access or interact with HighTable’s
                  platform.
                </p>
              </div>

              <div>
                <p>
                  13. Upload Harmful Code – Do not upload viruses, malware, or
                  anything that could compromise the platform’s security.
                </p>
              </div>

              <div>
                <p>
                  14. Manipulate Information – Do not forge identifiers or alter
                  information to disguise the origin of content transmitted on
                  the platform.
                </p>
              </div>

              <div>
                <p>
                  15. Misuse Trademarks – Do not use HighTable’s trademarks,
                  logos, or other intellectual property without prior written
                  consent.
                </p>
              </div>

              <div>
                <p>
                  16. Create Multiple Accounts – Do not create a new account if
                  your previous one has been suspended or terminated unless
                  explicitly authorized.
                </p>
              </div>

              <div>
                <p>
                  17. Engage in Unauthorized Data Collection – Do not use
                  automated tools (like data mining or scraping) to collect data
                  or content from the platform.
                </p>
              </div>

              <div>
                <p>
                  18. Circumvent Security Features – Do not bypass security
                  features or interfere with the functionality of the platform.
                </p>
              </div>

              <div>
                <p>
                  19. Disrupt the Platform’s Operations – Do not create
                  unnecessary load or cause disruption to the platform or its
                  users’ experience.
                </p>
              </div>

              <div>
                <p>
                  20. Attempt to Reverse Engineer the Service – Do not reverse
                  engineer, decompile, or disassemble any software or content
                  that is part of HighTable.
                </p>
              </div>
            </body>

            <h2>
              <strong>8. USER GENERATED CONTRIBUTIONS</strong>
            </h2>
            <p>
              The Services does not offer users to submit or post content. We
              may provide you with the opportunity to create, submit, post,
              display, transmit, perform, publish, distribute, or broadcast
              content and materials to us or on the Services, including but not
              limited to text, writings, video, audio, photographs, graphics,
              comments, suggestions, or personal information or other material
              (collectively, "Contributions"). Contributions may be viewable by
              other users of the Services and through third-party websites. When
              you create or make available any Contributions, you thereby
              represent and warrant that:
            </p>
            <ul role="list">
              <li>
                The creation, distribution, transmission, public display, or
                performance, and the accessing, downloading, or copying of your
                Contributions do not and will not infringe the proprietary
                rights, including but not limited to the copyright, patent,
                trademark, trade secret, or moral rights of any third party.
              </li>
              <li>
                You are the creator and owner of or have the necessary licenses,
                rights, consents, releases, and permissions to use and to
                authorize us, the Services, and other users of the Services to
                use your Contributions in any manner contemplated by the
                Services and these Legal Terms.
              </li>
              <li>
                You have the written consent, release, and/or permission of each
                and every identifiable individual person in your Contributions
                to use the name or likeness of each and every such identifiable
                individual person to enable inclusion and use of your
                Contributions in any manner contemplated by the Services and
                these Legal Terms.
              </li>
              <li>
                Your Contributions are not false, inaccurate, or misleading.
              </li>
              <li>
                Your Contributions are not unsolicited or unauthorized
                advertising, promotional materials, pyramid schemes, chain
                letters, spam, mass mailings, or other forms of solicitation.
              </li>
              <li>
                Your Contributions are not obscene, lewd, lascivious, filthy,
                violent, harassing, libelous, slanderous, or otherwise
                objectionable (as determined by us).
              </li>
              <li>
                Your Contributions do not ridicule, mock, disparage, intimidate,
                or abuse anyone.
              </li>
              <li>
                Your Contributions are not used to harass or threaten (in the
                legal sense of those terms) any other person and to promote
                violence against a specific person or class of people.
              </li>
              <li>
                Your Contributions do not violate any applicable law,
                regulation, or rule.
              </li>
              <li>
                Your Contributions do not violate the privacy or publicity
                rights of any third party.
              </li>
              <li>
                Your Contributions do not violate any applicable law concerning
                child pornography, or otherwise intended to protect the health
                or well-being of minors.
              </li>
              <li>
                Your Contributions do not include any offensive comments that
                are connected to race, national origin, gender, sexual
                preference, or physical handicap.
              </li>
              <li>
                Your Contributions do not otherwise violate, or link to material
                that violates, any provision of these Legal Terms, or any
                applicable law or regulation.
              </li>
            </ul>
            <h1>
              Any use of the Services in violation of the foregoing violates
              these Legal Terms and may result in, among other things,
              termination or suspension of your rights to use the Services.
            </h1>
            <h2>
              <strong>9. CONTRIBUTION LICENSE</strong>
            </h2>
            <p>
              You and Services agree that we may access, store, process, and use
              any information and personal data that you provide and your
              choices (including settings).
            </p>
            <p>
              By submitting suggestions or other feedback regarding the
              Services, you agree that we can use and share such feedback for
              any purpose without compensation to you.
            </p>
            <p>
              We do not assert any ownership over your Contributions. You retain
              full ownership of all of your Contributions and any intellectual
              property rights or other proprietary rights associated with your
              Contributions. We are not liable for any statements or
              representations in your Contributions provided by you in any area
              on the Services. You are solely responsible for your Contributions
              to the Services and you expressly agree to exonerate us from any
              and all responsibility and to refrain from any legal action
              against us regarding your Contributions.
            </p>
            <h2>
              <strong>10. SOCIAL MEDIA</strong>
            </h2>
            <p>
              As part of the functionality of the Services, you may link your
              account with online accounts you have with third-party service
              providers (each such account, a "Third-Party Account") by either:
              (1) providing your Third-Party Account login information through
              the Services; or (2) allowing us to access your Third-Party
              Account, as is permitted under the applicable terms and conditions
              that govern your use of each Third-Party Account. You represent
              and warrant that you are entitled to disclose your Third-Party
              Account login information to us and/or grant us access to your
              Third-Party Account, without breach by you of any of the terms and
              conditions that govern your use of the applicable Third-Party
              Account, and without obligating us to pay any fees or making us
              subject to any usage limitations imposed by the third-party
              service provider of the Third-Party Account. By granting us access
              to any Third-Party Accounts, you understand that (1) we may
              access, make available, and store (if applicable) any content that
              you have provided to and stored in your Third-Party Account (the
              "Social Network Content") so that it is available on and through
              the Services via your account, including without limitation any
              friend lists and (2) we may submit to and receive from your
              Third-Party Account additional information to the extent you are
              notified when you link your account with the Third-Party Account.
              Depending on the Third-Party Accounts you choose and subject to
              the privacy settings that you have set in such Third-Party
              Accounts, personally identifiable information that you post to
              your Third-Party Accounts may be available on and through your
              account on the Services. Please note that if a Third-Party Account
              or associated service becomes unavailable or our access to such
              Third-Party Account is terminated by the third-party service
              provider, then Social Network Content may no longer be available
              on and through the Services. You will have the ability to disable
              the connection between your account on the Services and your
              Third-Party Accounts at any time. PLEASE NOTE THAT YOUR
              RELATIONSHIP WITH THE THIRD-PARTY SERVICE PROVIDERS ASSOCIATED
              WITH YOUR THIRD-PARTY ACCOUNTS IS GOVERNED SOLELY BY YOUR
              AGREEMENT(S) WITH SUCH THIRD-PARTY SERVICE PROVIDERS. We make no
              effort to review any Social Network Content for any purpose,
              including but not limited to, for accuracy, legality, or
              non-infringement, and we are not responsible for any Social
              Network Content. You acknowledge and agree that we may access your
              email address book associated with a Third-Party Account and your
              contacts list stored on your mobile device or tablet computer
              solely for purposes of identifying and informing you of those
              contacts who have also registered to use the Services. You can
              deactivate the connection between the Services and your
              Third-Party Account by contacting us using the contact information
              below or through your account settings (if applicable). We will
              attempt to delete any information stored on our servers that was
              obtained through such Third-Party Account, except the username and
              profile picture that become associated with your account.
            </p>
            <h2>
              <strong>11. THIRD-PARTY WEBSITES AND CONTENT</strong>
            </h2>
            <p>
              The Services may contain (or you may be sent via the Site) links
              to other websites ("Third-Party Websites") as well as articles,
              photographs, text, graphics, pictures, designs, music, sound,
              video, information, applications, software, and other content or
              items belonging to or originating from third parties ("Third-Party
              Content"). Such Third-Party Websites and Third-Party Content are
              not investigated, monitored, or checked for accuracy,
              appropriateness, or completeness by us, and we are not responsible
              for any Third-Party Websites accessed through the Services or any
              Third-Party Content posted on, available through, or installed
              from the Services, including the content, accuracy, offensiveness,
              opinions, reliability, privacy practices, or other policies of or
              contained in the Third-Party Websites or the Third-Party Content.
              Inclusion of, linking to, or permitting the use or installation of
              any Third-Party Websites or any Third-Party Content does not imply
              approval or endorsement thereof by us. If you decide to leave the
              Services and access the Third-Party Websites or to use or install
              any Third-Party Content, you do so at your own risk, and you
              should be aware these Legal Terms no longer govern. You should
              review the applicable terms and policies, including privacy and
              data gathering practices, of any website to which you navigate
              from the Services or relating to any applications you use or
              install from the Services. Any purchases you make through
              Third-Party Websites will be through other websites and from other
              companies, and we take no responsibility whatsoever in relation to
              such purchases which are exclusively between you and the
              applicable third party. You agree and acknowledge that we do not
              endorse the products or services offered on Third-Party Websites
              and you shall hold us blameless from any harm caused by your
              purchase of such products or services. Additionally, you shall
              hold us blameless from any losses sustained by you or harm caused
              to you relating to or resulting in any way from any Third-Party
              Content or any contact with Third-Party Websites.
            </p>
            <h2>
              <strong>12. SERVICES MANAGEMENT</strong>
            </h2>
            <p>
              We reserve the right, but not the obligation, to: (1) monitor the
              Services for violations of these Legal Terms; (2) take appropriate
              legal action against anyone who, in our sole discretion, violates
              the law or these Legal Terms, including without limitation,
              reporting such user to law enforcement authorities; (3) in our
              sole discretion and without limitation, refuse, restrict access
              to, limit the availability of, or disable (to the extent
              technologically feasible) any of your Contributions or any portion
              thereof; (4) in our sole discretion and without limitation,
              notice, or liability, to remove from the Services or otherwise
              disable all files and content that are excessive in size or are in
              any way burdensome to our systems; and (5) otherwise manage the
              Services in a manner designed to protect our rights and property
              and to facilitate the proper functioning of the Services.
            </p>
            <h2>
              <strong>13. PRIVACY POLICY</strong>
            </h2>
            <p>
              We care about data privacy and security. By using the Services,
              you agree to be bound by our Privacy Policy posted on the
              Services, which is incorporated into these Legal Terms. Please be
              advised the Services are hosted in India. If you access the
              Services from any other region of the world with laws or other
              requirements governing personal data collection, use, or
              disclosure that differ from applicable laws in India, then through
              your continued use of the Services, you are transferring your data
              to India, and you expressly consent to have your data transferred
              to and processed in India.
            </p>
            <h2>
              <strong>14. TERM AND TERMINATION</strong>
            </h2>
            <p>
              These Legal Terms shall remain in full force and effect while you
              use the Services. WITHOUT LIMITING ANY OTHER PROVISION OF THESE
              LEGAL TERMS, WE RESERVE THE RIGHT TO, IN OUR SOLE DISCRETION AND
              WITHOUT NOTICE OR LIABILITY, DENY ACCESS TO AND USE OF THE
              SERVICES (INCLUDING BLOCKING CERTAIN IP ADDRESSES), TO ANY PERSON
              FOR ANY REASON OR FOR NO REASON, INCLUDING WITHOUT LIMITATION FOR
              BREACH OF ANY REPRESENTATION, WARRANTY, OR COVENANT CONTAINED IN
              THESE LEGAL TERMS OR OF ANY APPLICABLE LAW OR REGULATION. WE MAY
              TERMINATE YOUR USE OR PARTICIPATION IN THE SERVICES OR DELETE YOUR
              ACCOUNT AND ANY CONTENT OR INFORMATION THAT YOU POSTED AT ANY
              TIME, WITHOUT WARNING, IN OUR SOLE DISCRETION.
            </p>
            <p>
              If we terminate or suspend your account for any reason, you are
              prohibited from registering and creating a new account under your
              name, a fake or borrowed name, or the name of any third party,
              even if you may be acting on behalf of the third party. In
              addition to terminating or suspending your account, we reserve the
              right to take appropriate legal action, including without
              limitation pursuing civil, criminal, and injunctive redress.
            </p>
            <h2>
              <strong>15. MODIFICATIONS AND INTERRUPTIONS</strong>
            </h2>
            <p>
              We reserve the right to change, modify, or remove the contents of
              the Services at any time or for any reason at our sole discretion
              without notice. However, we have no obligation to update any
              information on our Services. We will not be liable to you or any
              third party for any modification, price change, suspension, or
              discontinuance of the Services.
            </p>
            <p>
              We cannot guarantee the Services will be available at all times.
              We may experience hardware, software, or other problems or need to
              perform maintenance related to the Services, resulting in
              interruptions, delays, or errors. We reserve the right to change,
              revise, update, suspend, discontinue, or otherwise modify the
              Services at any time or for any reason without notice to you. You
              agree that we have no liability whatsoever for any loss, damage,
              or inconvenience caused by your inability to access or use the
              Services during any downtime or discontinuance of the Services.
              Nothing in these Legal Terms will be construed to obligate us to
              maintain and support the Services or to supply any corrections,
              updates, or releases in connection therewith.
            </p>
            <h2>
              <strong>16. GOVERNING LAW</strong>
            </h2>
            <p>
              These Legal Terms shall be governed by and defined following the
              laws of India. High Table Network Private Limited and yourself
              irrevocably consent that the courts of India shall have exclusive
              jurisdiction to resolve any dispute which may arise in connection
              with these Legal Terms.
            </p>
            <h2>
              <strong>17. DISPUTE RESOLUTION</strong>
            </h2>
            <h3>
              <strong>Informal Negotiations</strong>
            </h3>
            <p>
              To expedite resolution and control the cost of any dispute,
              controversy, or claim related to these Legal Terms (each a
              "Dispute" and collectively, the "Disputes") brought by either you
              or us (individually, a "Party" and collectively, the "Parties"),
              the Parties agree to first attempt to negotiate any Dispute
              (except those Disputes expressly provided below) informally for at
              least __________ days before initiating arbitration. Such informal
              negotiations commence upon written notice from one Party to the
              other Party.
            </p>
            <h3>
              <strong>Binding Arbitration</strong>
            </h3>
            <p>
              Any dispute arising out of or in connection with these Legal
              Terms, including any question regarding its existence, validity,
              or termination, shall be referred to and finally resolved by the
              International Commercial Arbitration Court under the European
              Arbitration Chamber (Belgium, Brussels, Avenue Louise, 146)
              according to the Rules of this ICAC, which, as a result of
              referring to it, is considered as the part of this clause. The
              number of arbitrators shall be __________. The seat, or legal
              place, or arbitration shall be India. The language of the
              proceedings shall be __________. The governing law of these Legal
              Terms shall be substantive law of India.
            </p>
            <h3>
              <strong>Restrictions</strong>
            </h3>
            <p>
              The Parties agree that any arbitration shall be limited to the
              Dispute between the Parties individually. To the full extent
              permitted by law, (a) no arbitration shall be joined with any
              other proceeding; (b) there is no right or authority for any
              Dispute to be arbitrated on a class-action basis or to utilize
              class action procedures; and (c) there is no right or authority
              for any Dispute to be brought in a purported representative
              capacity on behalf of the general public or any other persons.
            </p>
            <h3>
              <strong>
                Exceptions to Informal Negotiations and Arbitration
              </strong>
            </h3>
            <p>
              The Parties agree that the following Disputes are not subject to
              the above provisions concerning informal negotiations binding
              arbitration: (a) any Disputes seeking to enforce or protect, or
              concerning the validity of, any of the intellectual property
              rights of a Party; (b) any Dispute related to, or arising from,
              allegations of theft, piracy, invasion of privacy, or unauthorized
              use; and (c) any claim for injunctive relief. If this provision is
              found to be illegal or unenforceable, then neither Party will
              elect to arbitrate any Dispute falling within that portion of this
              provision found to be illegal or unenforceable and such Dispute
              shall be decided by a court of competent jurisdiction within the
              courts listed for jurisdiction above, and the Parties agree to
              submit to the personal jurisdiction of that court.
            </p>
            <h2>
              <strong>18. CORRECTIONS</strong>
            </h2>
            <p>
              There may be information on the Services that contains
              typographical errors, inaccuracies, or omissions, including
              descriptions, pricing, availability, and various other
              information. We reserve the right to correct any errors,
              inaccuracies, or omissions and to change or update the information
              on the Services at any time, without prior notice.
            </p>
            <h2>
              <strong>19. DISCLAIMER</strong>
            </h2>
            <p>
              THE SERVICES ARE PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. YOU
              AGREE THAT YOUR USE OF THE SERVICES WILL BE AT YOUR SOLE RISK. TO
              THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES,
              EXPRESS OR IMPLIED, IN CONNECTION WITH THE SERVICES AND YOUR USE
              THEREOF, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
              NON-INFRINGEMENT. WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT
              THE ACCURACY OR COMPLETENESS OF THE SERVICES' CONTENT OR THE
              CONTENT OF ANY WEBSITES OR MOBILE APPLICATIONS LINKED TO THE
              SERVICES AND WE WILL ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY
              (1) ERRORS, MISTAKES, OR INACCURACIES OF CONTENT AND MATERIALS,
              (2) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER,
              RESULTING FROM YOUR ACCESS TO AND USE OF THE SERVICES, (3) ANY
              UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND
              ALL PERSONAL INFORMATION AND/OR FINANCIAL INFORMATION STORED
              THEREIN, (4) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR
              FROM THE SERVICES, (5) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE
              LIKE WHICH MAY BE TRANSMITTED TO OR THROUGH THE SERVICES BY ANY
              THIRD PARTY, AND/OR (6) ANY ERRORS OR OMISSIONS IN ANY CONTENT AND
              MATERIALS OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A
              RESULT OF THE USE OF ANY CONTENT POSTED, TRANSMITTED, OR OTHERWISE
              MADE AVAILABLE VIA THE SERVICES. WE DO NOT WARRANT, ENDORSE,
              GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SERVICE
              ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH THE SERVICES, ANY
              HYPERLINKED WEBSITE, OR ANY WEBSITE OR MOBILE APPLICATION FEATURED
              IN ANY BANNER OR OTHER ADVERTISING, AND WE WILL NOT BE A PARTY TO
              OR IN ANY WAY BE RESPONSIBLE FOR MONITORING ANY TRANSACTION
              BETWEEN YOU AND ANY THIRD-PARTY PROVIDERS OF PRODUCTS OR SERVICES.
              AS WITH THE PURCHASE OF A PRODUCT OR SERVICE THROUGH ANY MEDIUM OR
              IN ANY ENVIRONMENT, YOU SHOULD USE YOUR BEST JUDGMENT AND EXERCISE
              CAUTION WHERE APPROPRIATE.
            </p>
            <h2>
              <strong>20. LIMITATIONS OF LIABILITY</strong>
            </h2>
            <p>
              IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE
              LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT,
              CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE
              DAMAGES, INCLUDING LOST PROFIT, LOST REVENUE, LOSS OF DATA, OR
              OTHER DAMAGES ARISING FROM YOUR USE OF THE SERVICES, EVEN IF WE
              HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
              NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, OUR
              LIABILITY TO YOU FOR ANY CAUSE WHATSOEVER AND REGARDLESS OF THE
              FORM OF THE ACTION, WILL AT ALL TIMES BE LIMITED TO THE LESSER OF
              THE AMOUNT PAID, IF ANY, BY YOU TO US OR . CERTAIN US STATE LAWS
              AND INTERNATIONAL LAWS DO NOT ALLOW LIMITATIONS ON IMPLIED
              WARRANTIES OR THE EXCLUSION OR LIMITATION OF CERTAIN DAMAGES. IF
              THESE LAWS APPLY TO YOU, SOME OR ALL OF THE ABOVE DISCLAIMERS OR
              LIMITATIONS MAY NOT APPLY TO YOU, AND YOU MAY HAVE ADDITIONAL
              RIGHTS.
            </p>
            <h2>
              <strong>21. INDEMNIFICATION</strong>
            </h2>
            <p>
              You agree to defend, indemnify, and hold us harmless, including
              our subsidiaries, affiliates, and all of our respective officers,
              agents, partners, and employees, from and against any loss,
              damage, liability, claim, or demand, including reasonable
              attorneys’ fees and expenses, made by any third party due to or
              arising out of: (1) use of the Services; (2) breach of these Legal
              Terms; (3) any breach of your representations and warranties set
              forth in these Legal Terms; (4) your violation of the rights of a
              third party, including but not limited to intellectual property
              rights; or (5) any overt harmful act toward any other user of the
              Services with whom you connected via the Services. Notwithstanding
              the foregoing, we reserve the right, at your expense, to assume
              the exclusive defense and control of any matter for which you are
              required to indemnify us, and you agree to cooperate, at your
              expense, with our defense of such claims. We will use reasonable
              efforts to notify you of any such claim, action, or proceeding
              which is subject to this indemnification upon becoming aware of
              it.
            </p>
            <h2>
              <strong>22. USER DATA</strong>
            </h2>
            <p>
              We will maintain certain data that you transmit to the Services
              for the purpose of managing the performance of the Services, as
              well as data relating to your use of the Services. Although we
              perform regular routine backups of data, you are solely
              responsible for all data that you transmit or that relates to any
              activity you have undertaken using the Services. You agree that we
              shall have no liability to you for any loss or corruption of any
              such data, and you hereby waive any right of action against us
              arising from any such loss or corruption of such data.
            </p>
            <h2>
              <strong>
                23. ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES
              </strong>
            </h2>
            <p>
              Visiting the Services, sending us emails, and completing online
              forms constitute electronic communications. You consent to receive
              electronic communications, and you agree that all agreements,
              notices, disclosures, and other communications we provide to you
              electronically, via email and on the Services, satisfy any legal
              requirement that such communication be in writing. YOU HEREBY
              AGREE TO THE USE OF ELECTRONIC SIGNATURES, CONTRACTS, ORDERS, AND
              OTHER RECORDS, AND TO ELECTRONIC DELIVERY OF NOTICES, POLICIES,
              AND RECORDS OF TRANSACTIONS INITIATED OR COMPLETED BY US OR VIA
              THE SERVICES. You hereby waive any rights or requirements under
              any statutes, regulations, rules, ordinances, or other laws in any
              jurisdiction which require an original signature or delivery or
              retention of non-electronic records, or to payments or the
              granting of credits by any means other than electronic means.
            </p>
            <h2>
              <strong>24. MISCELLANEOUS</strong>
            </h2>
            <p>
              These Legal Terms and any policies or operating rules posted by us
              on the Services or in respect to the Services constitute the
              entire agreement and understanding between you and us. Our failure
              to exercise or enforce any right or provision of these Legal Terms
              shall not operate as a waiver of such right or provision. These
              Legal Terms operate to the fullest extent permissible by law. We
              may assign any or all of our rights and obligations to others at
              any time. We shall not be responsible or liable for any loss,
              damage, delay, or failure to act caused by any cause beyond our
              reasonable control. If any provision or part of a provision of
              these Legal Terms is determined to be unlawful, void, or
              unenforceable, that provision or part of the provision is deemed
              severable from these Legal Terms and does not affect the validity
              and enforceability of any remaining provisions. There is no joint
              venture, partnership, employment or agency relationship created
              between you and us as a result of these Legal Terms or use of the
              Services. You agree that these Legal Terms will not be construed
              against us by virtue of having drafted them. You hereby waive any
              and all defenses you may have based on the electronic form of
              these Legal Terms and the lack of signing by the parties hereto to
              execute these Legal Terms.
            </p>
            <h2>
              <strong>25. CONTACT US</strong>
            </h2>
            <p>
              In order to resolve a complaint regarding the Services or to
              receive further information regarding use of the Services, please
              contact us at:
            </p>
            <p>
              <strong>High Table Network Private Limited</strong>
            </p>
            <p>
              <strong>
                Adya 13 &amp; 14, No 4, 6 Cross, 9th Main, Srinivagilu Main Road
              </strong>
            </p>
            <p>
              <strong>Near Koramangala bus depot, Koramangala</strong>
            </p>
            <p>
              <strong>Bangalore, Karnataka 560047</strong>
            </p>
            <p>
              <strong>India</strong>
            </p>
            <p>
              <strong>Phone: +919036433636</strong>
            </p>
            <p>
              <strong>support@hightable.ai</strong>
            </p>
            <h1>‍</h1>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Terms;
